var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.model)?_c('third-party-form',{attrs:{"data":_vm.model,"title":_vm.$t('thirdParties.edit.title', { name: _vm.model ? _vm.model.name : ''}),"submit-loading":_vm.submitLoading},on:{"submit":_vm.onSubmit}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }